import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Product } from "../../../types/api/Product";
import { Nullable } from "../../../utils/Nullable";
import { useParams } from "react-router-dom";

import useUpdateInventory from "../../../queries/routes/useUpdateInventory";

interface InventoryDialogProps {
  product: Nullable<Product>;
  open: boolean;
  setClosed: () => void;
}

export default function InventoryDialog({
  open,
  product,
  setClosed,
}: InventoryDialogProps) {
  const { org_id } = useParams();
  const [count, setCount] = React.useState(0);
  const { mutate: updateInventory } = useUpdateInventory(org_id!);

  const handleClose = () => {
    setClosed();
  };

  if (!product) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Inventory for {product.name}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Change inventory for this product.
        </DialogContentText>

        <TextField
          sx={{ mt: 2 }}
          autoFocus
          margin="dense"
          id="name"
          label="Count"
          type="number"
          fullWidth
          variant="outlined"
          value={count}
          onChange={(event) => setCount(Number(event.target.value))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => {
            updateInventory({
              count: count,
              product: { id: product.id },
              inventory_transaction_type: "add",
            });
            handleClose();
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
